import type { ReactNode } from 'react';
import styles from './StatusPill.module.css';

interface Props {
  bg: string;
  text: string;
  label: string;
  /** Optional tooltip, e.g. the raw status code for ops. */
  title?: string;
  /** Optional icon (e.g. <StatusIcon>) shown before the word; hidden from screen readers (the word carries it). */
  icon?: ReactNode;
}

export function StatusPill({ bg, text, label, title, icon }: Props) {
  return (
    <span
      className={styles.pill}
      title={title}
      style={{ '--pill-bg': bg, '--pill-text': text } as React.CSSProperties}
    >
      {icon && (
        <span className={styles.icon} aria-hidden="true">
          {icon}
        </span>
      )}
      {label}
    </span>
  );
}
